import { useMutation, useQueryClient } from 'react-query'
import { message } from 'antd'
import { postJSON } from 'common/services/api'

type UseDeviceRecordDocumentRemoveProps = {
  residentId: string
}

type UseDeviceRecordDocumentRemoveReturn = {
  removeDocument: (recordId: string, documents: string[]) => Promise<void>
  isRemoving: boolean
}

export const useDeviceRecordDocumentRemove = ({
  residentId
}: UseDeviceRecordDocumentRemoveProps): UseDeviceRecordDocumentRemoveReturn => {
  const queryClient = useQueryClient()

  const mutation = useMutation(
    async ({
      recordId,
      documents
    }: {
      recordId: string
      documents: string[]
    }) => {
      await postJSON({
        url: `/v6/residents/device-records/${recordId}`,
        method: 'PATCH',
        json: { documents }
      })
    },
    {
      onSuccess: () => {
        message.success('Document removed')
        queryClient.invalidateQueries(['device-records', residentId])
      },
      onError: (error: any) => {
        message.error(error?.message || 'Failed to remove document')
      }
    }
  )

  const removeDocument = async (recordId: string, documents: string[]) => {
    await mutation.mutateAsync({ recordId, documents })
  }

  return {
    removeDocument,
    isRemoving: mutation.isLoading
  }
}
